import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as CreditCardMdl from '../models/CreditCardModel';
import * as myCfg from '../AppConfig';
import { APIContainer, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as ARInvoiceMdl from '../models/ArInvoiceModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ChargeCreditCard { type: 'CREDITCARD_CHARGERESULT', newState: CreditCardMdl.CreditCardProcess }
export interface ChargeCreditProcessing{ type: 'CREDITCARD_PROCESSING' }
export interface ChargeCreditError { type: 'CREDITCARD_ERROR', error: string }
export interface ChargeCreditReset { type: 'CREDITCARD_RESETINFO'}

export type KnownAction = ChargeCreditCard | ChargeCreditProcessing | ChargeCreditError | ChargeCreditReset;
 
export const actionCreators = {
    chargeCreditCard: (pCreditCardData: CreditCardMdl.CreditCardModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
        const invoicesAR: ARInvoiceMdl.ArInvoiceModel[] = appState.openInvoicesState.items.filter(x => x.isSelectedToPay == true);
        var ChargeInvoiceMdl: CreditCardMdl.ChargeInvoicesModel = CreditCardMdl.initialStateCargeModel;
        var invoicesToCharge: CreditCardMdl.CreditCardARInvoice[] = [];

        invoicesToCharge = invoicesAR.map((item, index) => {
            return {
                ...CreditCardMdl.initialStateCreditCardARInvoice, ...{
                    companyCode: sessionState.SelectedAR.companyCode,
                    invoiceNumber: item.invoiceNumber,
                    sMName: sessionState.SelectedSM.name.displayName,
                    aRName: sessionState.SelectedAR.name.displayName,
                    invoiceAmount: item.total,
                    balance: item.balanceDue,
                    toBeProcessed: true,
                    aRNum: sessionState.SelectedAR.id,
                    invoiceDate: item.invoiceDate,
                    amountToCharge: item.balanceDue
                }
            };
        })       

        ChargeInvoiceMdl = {
            ...CreditCardMdl.initialStateCargeModel, ...{
                invoices: invoicesToCharge,
                creditCardInfo: pCreditCardData,
                companyCode: sessionState.SelectedAR.companyCode,
                entityCode: 'Customer',
                entityType: 'C'
            }
        };        
        
        dispatch({ type: 'CREDITCARD_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/MxMerchant',
            {
                method: 'POST',
                body: JSON.stringify(ChargeInvoiceMdl),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {

               

                const data: CreditCardMdl.ChargeInvoicesModel = container.data;
           
                var notProcessed: number = 0;
                var totalInvoices: number = data.invoices.length;

                data.invoices.forEach((item, index) => {
                    if (!item.autCode || item.autCode.length == 0) {
                        notProcessed++;
                    }
                });

                var creditCardResult: CreditCardMdl.CreditCardProcess = { ...CreditCardMdl.CreditCardProcessIntialState };                

                if (totalInvoices == notProcessed) {
                    creditCardResult.error = `Error processing Credit Card ${container.errorInfo.message} `;
                    creditCardResult.success = false;
                    creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                } else if (notProcessed != 0 && totalInvoices != notProcessed) {
                    creditCardResult.error = `${notProcessed - totalInvoices} of ${totalInvoices} processed`;
                    creditCardResult.success = false;
                    creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                } else if (totalInvoices == 0) {
                    creditCardResult.error = "No Credit Card was processed";
                    creditCardResult.success = false;
                    creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                } else {                   
                    creditCardResult.error = "";
                    creditCardResult.success = true;
                    creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                }
                
                dispatch({ type: 'CREDITCARD_CHARGERESULT', newState: creditCardResult });
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CREDITCARD_ERROR', error: err.message
                })
            });
    }
};

export const reducer: Reducer<CreditCardMdl.CreditCardProcess> = (state: CreditCardMdl.CreditCardProcess | undefined, incomingAction: Action): CreditCardMdl.CreditCardProcess => {

    if (state === undefined) {
        return { ...CreditCardMdl.CreditCardProcessIntialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CREDITCARD_PROCESSING':
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.InProcesses, }
        case 'CREDITCARD_CHARGERESULT':
            const chargeCreditCardAction = incomingAction as ChargeCreditCard;
            return { ...chargeCreditCardAction.newState, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished}
        case 'CREDITCARD_ERROR':
            const chargeCreditErrorAction = incomingAction as ChargeCreditError;
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished, error: chargeCreditErrorAction.error, success:false }
        case 'CREDITCARD_RESETINFO':
            return { ...CreditCardMdl.CreditCardProcessIntialState };          
        default:
            return state;
    }
}; 